import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import Resumen from "./Resumen";
import {
  QUERY_LEER_CARRITO,
  useExisteCarrito,
  useLeerCarrito,
} from "../../../services/carritoServicios";
import InformationModal from "../../organisms/InformationModal";
import { useNavigate } from "react-router-dom";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { LoadingCarrito } from "./LoadingCarrito";
import { useQueryClient } from "@tanstack/react-query";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/carrito",
    label: "Carrito",
    isActive: true,
  },
];

function Carrito() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    data: existeCarrito,
    isLoading: existeCarritoIsLoading,
    isError: existeCarritoIsError,
    isSuccess: existeCarritoIsSuccess,
  } = useExisteCarrito();

  const {
    data: carrito,
    isLoading: carritoIsLoading,
    isError: carritoIsError,
  } = useLeerCarrito(existeCarritoIsSuccess && existeCarrito);

  const isLoading = existeCarritoIsLoading || carritoIsLoading;
  const isError = existeCarritoIsError || carritoIsError;

  if (isError) {
    return <ServerErrorModal />;
  }

  const onModalClose = () => {
    navigate("/");
  };

  const onReemplazoCarritoSuccess = () => {
    queryClient.invalidateQueries([QUERY_LEER_CARRITO]);
  };

  if (existeCarritoIsSuccess && !existeCarrito) {
    return (
      <InformationModal
        message={"No existe carrito para este usuario"}
        onClose={onModalClose}
      />
    );
  }

  return (
    <>
      {isError && <ServerErrorModal onClose={onModalClose} />}
      <Page
        title="Carrito"
        description="Carrito de servicios para un propietario."
        breadCrumbs={breadCrumbs}
      >
        {carrito && !isLoading && (
          <Resumen
            carrito={carrito}
            onReemplazoCarritoSuccess={onReemplazoCarritoSuccess}
          />
        )}
        {isLoading && <LoadingCarrito />}
      </Page>
    </>
  );
}

export default Carrito;
